module.exports = __webpack_public_path__ + "static/img/logo_oficial_ministerio_justicia_1024.eadc46b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_oficial_ministerio_justicia_1024.png
// module id = FtcC
// module chunks = 9